import React from 'react';
import Icon from '../Icon';

const TONES = {
  green: 'green', success: 'success', low: 'low',
  amber: 'amber', warning: 'warning', medium: 'medium',
  red: 'red', critical: 'critical',
  blue: 'blue', info: 'info',
  pink: 'pink',
  gray: 'gray', neutral: 'neutral',
  high: 'high',
};

function Badge({ tone = 'gray', solid = false, dot = true, children, className = '', style }) {
  const cls = solid ? 'badge-solid' : TONES[tone] || 'gray';
  return (
    <span className={`badge ${cls} ${className}`} style={style}>
      {children}
    </span>
  );
}

export function SevBadge({ level, children }) {
  const l = (level || '').toLowerCase();
  const cls = ['critical', 'high', 'medium', 'low'].includes(l) ? l : 'low';
  return <span className={`sev ${cls}`}>{children || level}</span>;
}

export function HealthBadge({ score }) {
  const s = Number(score);
  const cls = s >= 80 ? 'health-ok' : s >= 50 ? 'health-warn' : 'health-bad';
  return <span className={`health-score ${cls}`}>{score}</span>;
}

export default Badge;
